(ns common.schema.entities.fund.core
  (:require [common.eid :as eid]
            [common.roles :as roles]
            [common.schema.entities.fund.schema :as fund]
            [common.util :as cu]))

;; Verbatim copy of common.schema.entity-types's admin-check-fn/admin-delete-check-fn
;; (entity_types.cljc around line 327-334) - required here, not there, to avoid a
;; circular namespace dependency (entity_types.cljc requires this registry). Keep
;; in sync if the original ever changes.
(defn- admin-check-fn
  [{:keys [role]}]
  (roles/admin? role))

(defn- disable-permissions-check-fn
  [{:keys [tr] :as ctx}]
  (when-not (admin-check-fn ctx)
    (tr :only-admin-can-delete-this-entity)))

;; Verbatim copy of common.schema.entity-types's existing fund entry's
;; :entity/read-permissions-check-fn (entity_types.cljc around line 786-799).
(defn- read-permissions-check-fn
  [{:keys [account-current-permissions entity]}]
  (let [account-funds (:account-access-to-funds account-current-permissions)
        account-teams (:account-team-memberships account-current-permissions)]
    (boolean
     (or (contains? account-funds (eid/eid entity))
         (->> entity
              :fund/teams
              (cu/find-first
               (fn [team-id]
                 (contains? account-teams team-id))
               (comp
                (remove :common/disabled?)
                (keep eid/eid))))))))

(def entity-type-definition
  {:entity-type                  :entity.type/fund
   :schema                       fund/schema
   ;; Deliberately "Fund", not the legacy "Our fund". That wording existed to
   ;; separate the tenant's own managed vehicles from external fund investments,
   ;; but it confused customers and drew push-back, so it was changed on purpose.
   ;;
   ;; Known consequence, accepted for now and to be revisited: this renders
   ;; identically to :entity.type/fof-asset, whose name is also "Fund", so any
   ;; label built from an entity type alone cannot tell the two apart - e.g. a
   ;; creator-config association list can show two rows both reading "Fund ...".
   ;; Registering this type is what surfaced it: common.schema.entity-type-names
   ;; is (merge base-entities registry-names), so the registry's name now wins
   ;; over entity-type-names-base's, and common.localization/tr resolves
   ;; entity-type keywords through that map. Don't "fix" this back without the
   ;; product decision.
   :name                         {:en "Fund"}
   :plural                       {:en "Our funds"}
   :icon                         :fa-hand-holding-seedling
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn disable-permissions-check-fn
   ;; Explicitly false: fund's dedicated OpenSearch index already exists and
   ;; is populated via the legacy common.opensearch.entity-indices mechanism,
   ;; not the newer :entity/search-index?-driven
   ;; backend.search.dedicated.indexes/init! path - this key would otherwise
   ;; default to true just because :search is present below.
   :search-index?                false
   :search                       {:result/title-attr :fund/name
                                  :list/default-columns [:fund/name
                                                         :fund/status
                                                         :fund/cur-fund-size
                                                         :fund/first-closing-date
                                                         :fund/vintage-year
                                                         :fund/cur-total-committed-capital
                                                         :fund/cur-total-called-capital]
                                  :views {:grid {:po-default-field-paths [[:fund/name]
                                                                          [:fund/status]
                                                                          [:fund/cur-fund-size]
                                                                          [:fund/first-closing-date]
                                                                          [:fund/vintage-year]
                                                                          [:fund/cur-total-committed-capital]
                                                                          [:fund/cur-total-called-capital]]
                                                :mandatory-field-paths [[:fund/name]]}}}})
